var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupCovered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3363_229414)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#219653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.473 16.8067C26.411 16.7442 26.3373 16.6946 26.256 16.6607C26.1748 16.6269 26.0876 16.6095 25.9996 16.6095C25.9116 16.6095 25.8245 16.6269 25.7433 16.6607C25.662 16.6946 25.5883 16.7442 25.5263 16.8067L20.5596 21.78L18.473 19.6867C18.4086 19.6245 18.3327 19.5756 18.2494 19.5428C18.1662 19.51 18.0773 19.4939 17.9879 19.4955C17.8984 19.497 17.8101 19.5162 17.7281 19.5518C17.646 19.5875 17.5718 19.639 17.5096 19.7033C17.4475 19.7677 17.3986 19.8436 17.3658 19.9269C17.333 20.0101 17.3169 20.099 17.3185 20.1885C17.32 20.2779 17.3392 20.3662 17.3748 20.4482C17.4105 20.5303 17.462 20.6045 17.5263 20.6667L20.0863 23.2267C20.1483 23.2892 20.222 23.3387 20.3033 23.3726C20.3845 23.4064 20.4716 23.4239 20.5596 23.4239C20.6476 23.4239 20.7348 23.4064 20.816 23.3726C20.8973 23.3387 20.971 23.2892 21.033 23.2267L26.473 17.7867C26.5406 17.7242 26.5946 17.6485 26.6316 17.5641C26.6685 17.4798 26.6876 17.3887 26.6876 17.2967C26.6876 17.2046 26.6685 17.1135 26.6316 17.0292C26.5946 16.9449 26.5406 16.8691 26.473 16.8067Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3363_229414",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3363_229414"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3363_229414",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupCovered);
export default __webpack_public_path__ + "static/media/group-covered.085a70a71c42fc0440e6636132515ecd.svg";
export { ForwardRef as ReactComponent };